import { Icon } from "../icon";
export const HexMapResourceTypeID = 'hexmap';
export const HexMapResourceType = {
    id: "hexmap",
    name: "Hex Map",
    pluralName: 'Hex Maps',
    icon: Icon.HEXMAP_ICON,
    initialName: 'New hex map',
    initialState: {},
};
//# sourceMappingURL=hexmap.js.map